import { modifier } from 'ember-modifier';

/** Selector for the floating DHTMLX tooltip nodes. */
const TOOLTIP_SELECTOR = '.dhtmlXTooltip.tooltip';

/**
 * Hide the stray DHTMLX tooltip while an edit form is open, restoring it on
 * teardown. Octane replacement for the `component-edit` mixin's
 * `didInsertElement` / `willDestroyElement` tooltip toggling (mixin-removal
 * Phase 1.5). Apply on the edit form root: `<form {{dhtmlx-tooltip-guard}}>`.
 */
var dhtmlxTooltipGuard = modifier(() => {
  document.querySelectorAll(TOOLTIP_SELECTOR).forEach(el => {
    el.style.display = 'none';
  });
  return () => {
    document.querySelectorAll(TOOLTIP_SELECTOR).forEach(el => {
      Object.assign(el.style, {
        visibility: 'hidden',
        display: 'block'
      });
    });
  };
});

export { dhtmlxTooltipGuard as default };
//# sourceMappingURL=dhtmlx-tooltip-guard.js.map
